import React from 'react';
import PropTypes from 'prop-types';
import { UniversalLink } from '@plone/volto/components';

const LinkListView = ({ data }) => {
  const items = data.items || [];
  if (data.variant === 'normatives') {
    return (
      <section className="agsus-specialized-care__normatives">
        <h2>{data.title || 'Normativas'}</h2>
        <ul>
          {items.map((item, idx) => (
            <li key={item.href || idx}>
              <UniversalLink href={item.href || '#'}>
                {item.label}
              </UniversalLink>
            </li>
          ))}
        </ul>
      </section>
    );
  }
  return (
    <section className="ag-linklist-section">
      {data.eyebrow && (
        <span className="ag-linklist-section__eyebrow">{data.eyebrow}</span>
      )}
      {data.title && (
        <h2 className="ag-linklist-section__heading">{data.title}</h2>
      )}
      <ul className="ag-link-list">
        {items.map((item, idx) => (
          <li key={idx}>
            <UniversalLink href={item.href || '#'}>
              <span className="ag-link-list__label">{item.label}</span>
              {item.meta && (
                <span className="ag-link-list__meta">{item.meta}</span>
              )}
            </UniversalLink>
          </li>
        ))}
      </ul>
    </section>
  );
};

LinkListView.propTypes = {
  data: PropTypes.shape({
    eyebrow: PropTypes.string,
    title: PropTypes.string,
    items: PropTypes.array,
    variant: PropTypes.string,
  }).isRequired,
};
export default LinkListView;
